import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import FormButton from "../../../components/form-button";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";

const INITIAL_VALUES = {
    ghost_mode: 0,
    hide_statistics: 0,
    hide_race_statistics: 0,
    exclude_rain: 0,
    receive_marketing_mails: 0,
}

const PreferencesSettings = () => {

    const {t} = useTranslation()
    const [values, setValues] = useState(INITIAL_VALUES)
    const [loading, setLoading] = useState([])

    const handleChange = (type, value) => {
        setValues(prevState => ({
            ...prevState,
            [type]: value
        }))
    }
    useEffect(() => {
        const handleApiResponse = (res) => setValues(res?.data)
        associateServices.profile({}).then(handleApiResponse)
    }, [])

    const handleUpdate = (val) => {
        setLoading(prevState => [...prevState, val])

        associateServices.updateProfile({...values,typeP:'preferences'}).then(res => {
            if (res?.status === 200) {
                setLoading(prevState => prevState.filter(i => i !== val))
                return toast(<InformationToast
                    title={t('settings.preferences.updated-title')}
                    message={t('settings.preferences.updated-message')}
                />)
            }
            return toast.success(t(`api-notifications.${res?.errors}`))

        })
    }

    return (

        <div
            className="tab-pane fade show active"
            id="tab-3" role="tabpanel"
            aria-labelledby="3-tab" tabIndex={0}>
            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.preferences.privacy')}
                </h3>
                <p className="settings__text">
                    {t('settings.preferences.privacy-desc')}
                </p>
                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form__switch">
                                        <input
                                            checked={values.ghost_mode}
                                            onChange={e => handleChange('ghost_mode', e.target.checked)}
                                            type="checkbox"
                                            className="form__switch-input"
                                            name="switch0"
                                            id="switch0"
                                        />
                                        <label htmlFor="switch0">
                                            <p>
                                                {t('settings.preferences.ghost-mode-title')}
                                            </p>
                                            <span>
                                                {t('settings.preferences.ghost-mode-desc')}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form__switch">
                                        <input
                                            checked={values.hide_statistics}
                                            onChange={e => handleChange('hide_statistics', e.target.checked)}
                                            type="checkbox"
                                            className="form__switch-input"
                                            name="switch1"
                                            id="switch1"
                                        />
                                        <label htmlFor="switch1">
                                            <p>
                                                {t('settings.preferences.hide-statistics-title')}
                                            </p>
                                            <span>
                                                {t('settings.preferences.hide-statistics-desc')}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form__switch">
                                        <input
                                            checked={values.hide_race_statistics}
                                            onChange={e => handleChange('hide_race_statistics', e.target.checked)}
                                            type="checkbox"
                                            className="form__switch-input"
                                            name="switch2"
                                            id="switch2"
                                        />
                                        <label htmlFor="switch2">
                                            <p>
                                                {t('settings.preferences.hide-race-statistics-title')}
                                            </p>
                                            <span>
                                                {t('settings.preferences.hide-race-statistics-desc')}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">
                    {/*<p className="settings__note">*/}
                    {/*    Please allow up to 30 seconds for update to take effect.*/}
                    {/*</p>*/}
                    <div className="settings__btns">
                        <FormButton
                            onClick={e => handleUpdate(1)}

                            isSmall={true}
                            label={t('settings.preferences.update')}
                            loading={loading?.includes(1)}
                            disabled={loading?.includes(1)}
                        />
                    </div>
                </div>
            </div>
            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.preferences.community')}
                </h3>
                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form__switch">
                                        <input
                                            checked={values.exclude_rain}
                                            onChange={e => handleChange('exclude_rain', e.target.checked)}

                                            type="checkbox"
                                            className="form__switch-input"
                                            name="switch3"
                                            id="switch3"
                                        />
                                        <label htmlFor="switch3">
                                            <p>
                                                {t('settings.preferences.exclude-from-rain-title')}
                                            </p>
                                            <span>
                                                {t('settings.preferences.exclude-from-rain-desc')}
                                </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">

                    <div className="settings__btns">


                        <FormButton
                            onClick={e => handleUpdate(2)}
                            isSmall={true}
                            label={t('settings.preferences.update')}
                            loading={loading?.includes(2)}
                            disabled={loading?.includes(2)}
                        />
                    </div>
                </div>
            </div>
            <div className="settings">
                <h3 className="settings__title">
                    {t('settings.preferences.marketing')}

                </h3>
                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form__switch">
                                        <input
                                            checked={values.receive_marketing_mails}
                                            onChange={e => handleChange('receive_marketing_mails', e.target.checked)}
                                            type="checkbox"
                                            className="form__switch-input"
                                            name="switch4"
                                            id="switch4"
                                        />
                                        <label htmlFor="switch4">
                                            <p>
                                                {t('settings.preferences.marketing-title')}
                                            </p>
                                            <span>
                                                {t('settings.preferences.marketing-desc')}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="settings__actions">
                    <div className="settings__btns">


                        <FormButton
                            onClick={e => handleUpdate(3)}
                            isSmall={true}
                            label={t('settings.preferences.update')}
                            loading={loading?.includes(3)}
                            disabled={loading?.includes(3)}
                        />
                    </div>
                </div>
            </div>


        </div>

    )

}


export default PreferencesSettings
